
webpack.register(
    'modules/tickets-and-hospitality/tickets-and-hospitality',
    function() {
        return import('modules/tickets-and-hospitality/tickets-and-hospitality');
    },
    true
);